
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[nonprofitSlugOrUsername]/learn",
      function () {
        return require("private-next-pages/[nonprofitSlugOrUsername]/learn.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[nonprofitSlugOrUsername]/learn"])
      });
    }
  